var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDsc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.028,
    height: 23.614,
    viewBox: "0 0 22.028 23.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.528,23.114l-10.264-5.632L1,23.114V1.5A1.5,1.5,0,0,1,2.5,0h17.028a1.5,1.5,0,0,1,1.5,1.5V23.114Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.264,15.982l7.8,4.284V3H3.464V20.266l7.8-4.284a.75.75,0,0,1,.75,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.264,
    cy: 12,
    r: 2.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.264,0A11.264,11.264,0,1,0,22.528,11.264,11.277,11.277,0,0,0,11.264,0Zm0,21.028a9.764,9.764,0,1,1,9.764-9.764A9.775,9.775,0,0,1,11.264,21.028Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsc);
export default __webpack_public_path__ + "static/media/dsc.0f4d1aefb6fd1cdac0002017db1fc896.svg";
export { ForwardRef as ReactComponent };